/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import Login from "../../sections/Login/Login";
import { SignUp } from "../../sections/SignUp/SignUp";
import MainButton from "../common/MainButton/MainButton";
import SideBarDrawer from "./SideBarDrawer";
import Avtar from "../../assets/img/default-image.jpg";
import useClickOutside from "../../Hooks/useClickOutside";
import AuxiliaryText from "../common/Typography/AuxiliaryText";
import SearchField from "../common/SearchInput/SearchField";
import InteractiveText from "../common/Typography/InteractiveText";
import SpecialText from "../common/Typography/SpecialText";
import AuthButtons from '../common/AuthButtons/AuthButtons';
import { NavHashLink } from "react-router-hash-link";
import { useSelector, useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import QuoteRequestForm from '../QuoteRequestForm/QuoteRequestForm';
import { useMobileDropdownData } from "./HeaderDropdownData";
import { DropdownRenderer } from "./DropdownRenderer";

const Navbar = ({
  isMobile,
  toggleDrawer,
  setSignUpState,
  SignUpState,
  setSignIn,
  SignIn,
  hideCategoriesAndPricing = false,
}) => {
  const location = useLocation();
  
  const [listOpen, setListOpen] = useState(false);
  const [postingOpen, setPostingOpen] = useState(false);
  const [subsOpen, setSubsOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [inboxOpen, setInboxOpen] = useState(false);
  const [quotesOpen, setQuotesOpen] = useState(false);
  const [ticketsOpen, setTicketsOpen] = useState(false);
  const [scrolledVersion, setScrolledVersion] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSidebarOpen, setIsSideBarOpen] = useState(false);
  const [notificationsAlerts, setNotificationsAlerts] = useState(false);
  const [quoteRequestOpen, setQuoteRequestOpen] = useState(false);
  const [pendingQuoteRequest, setPendingQuoteRequest] = useState(false);
  const { profilePicture } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const toggleDrawerState = () => {
    setIsOpen(!isOpen);
  };

  const { auth, setAuth } = useAuth();

  const [IsDropDownOpen, setDropDown] = useState(false);
  const { id: userId } = auth?.user ?? "";
  const ref = useRef(null);

  // Safe wrapper for toggleDrawer
  const safeToggleDrawer = () => {
    if (toggleDrawer) toggleDrawer();
  };

  // Get mobile dropdown data
  const mobileDropdownData = useMobileDropdownData({
    auth,
    setAuth,
    safeToggleDrawer,
    toggleDrawer,
    postingOpen,
    setPostingOpen,
    listOpen,
    setListOpen,
    helpOpen,
    setHelpOpen,
    inboxOpen,
    setInboxOpen,
    subsOpen,
    setSubsOpen,
    quotesOpen,
    setQuotesOpen,
    ticketsOpen,
    setTicketsOpen,
  });
  useClickOutside(ref, () => {
    setDropDown(false);
    setListOpen(false);
    setHelpOpen(false);
    setInboxOpen(false);
    setSubsOpen(false);
    setPostingOpen(false);
    setQuotesOpen(false);
    setTicketsOpen(false);
    setNotificationsAlerts(false);
  });

  // Handle automatic quote request form opening after login redirect
  useEffect(() => {
    if (auth?.user && pendingQuoteRequest) {
      setQuoteRequestOpen(true);
      setPendingQuoteRequest(false);
    }
  }, [auth?.user, pendingQuoteRequest]);

  // Handle Get free Quotes button click
  const handleRequestQuote = () => {
    if (auth?.user) {
      setQuoteRequestOpen(true);
      safeToggleDrawer(); // Close mobile drawer
    } else {
      setPendingQuoteRequest(true);
      dispatch(setRedirectPath(location.pathname + location.search));
      safeToggleDrawer(); // Close mobile drawer
      setSignIn(true);
    }
  };

  return (
    <>
      {/* Quote Request Form Popup */}
      <QuoteRequestForm
        isOpen={quoteRequestOpen}
        onClose={() => setQuoteRequestOpen(false)}
      />

      {/* Desktop Navigation */}
      <nav className="hidden lg:flex items-center flex-row menuItems">
        <ul className="flex items-center flex-row menuItems">
          {!hideCategoriesAndPricing && (
            <>
              <li className="mr-8 relative hover:text-primaryblue">
                <NavHashLink
                  to="/#categorie"
                  spy={true}
                  smooth={true}
                  offset={-88}
                  duration={500}
                  className="cursor-pointer"
                >
                  <AuxiliaryText variant={"NavigationText"}>
                    Categories
                  </AuxiliaryText>
                </NavHashLink>
              </li>
              <li className="mr-8 relative hover:text-primaryblue">
                <Link
                  to={"/pricing"}
                  className="cursor-pointer"
                >
                  <AuxiliaryText variant={"NavigationText"}>
                    Pricing
                  </AuxiliaryText>
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>

      <div className="flex items-center justify-center lg:hidden w-full">
        {/* Mobile Navigation Links */}
        <div className="w-full">
          <nav className="flex items-center flex-col overflow-hidden menuItems mb-4">
            <ul className="flex items-center flex-col menuItems">
              {!hideCategoriesAndPricing && (
                <>
                  <li className="mb-1 relative hover:text-primaryblue px-2 py-2 block">
                    <NavHashLink
                      to="/#categorie"
                      spy={true}
                      smooth={true}
                      offset={-88}
                      duration={500}
                      onClick={safeToggleDrawer}
                      className="cursor-pointer"
                    >
                      <AuxiliaryText variant={"NavigationText"}>
                        Categories
                      </AuxiliaryText>
                    </NavHashLink>
                  </li>
                  <li className="mb-1 relative hover:text-primaryblue px-2 py-2 block">
                    <Link
                      to={"/pricing"}
                      onClick={safeToggleDrawer}
                      className="cursor-pointer"
                    >
                      <AuxiliaryText variant={"NavigationText"}>
                        Pricing
                      </AuxiliaryText>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </div>
        
        {!auth?.user ? (
          <>
            <div className="grid grid-cols-1">
              <AuthButtons
                variant="mobile"
                onSignIn={() => setSignIn(!SignIn)}
                onSignUp={() => {
                  safeToggleDrawer();
                  setSignUpState(!SignUpState);
                }}
                showRequestQuote={false}
              />
            </div>
          </>
        ) : (
          <div className="pt-4 pb-3 w-full flex flex-col justify-center">
            {/* Get free Quote button now integrated into navigation menu */}
            
            <div className="flex items-center justify-center">
              <div className="flex-shrink-0">
                <img
                  className="h-12 w-12 rounded-full"
                  src={Avtar}
                  alt="Tradeposter User"
                />
              </div>
            </div>
            <div className="mt-3 space-y-1 flex flex-col items-center">
              {mobileDropdownData.map((item, index) => (
                <div key={index} className="w-full flex flex-col items-center">
                  {item.type === "link" ? (
                    <Link
                      to={item.link}
                      onClick={item.onClick}
                      className="block rounded-md py-2 hover:text-primaryblue ease-in-out px-2"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        {item.label}
                      </AuxiliaryText>
                    </Link>
                  ) : item.type === "dropdown" ? (
                    <>
                      <button
                        onClick={item.onClick}
                        className="flex justify-between px-2 py-2 hover:text-primaryblue ease-in-out w-[180px] my-1"
                      >
                        <AuxiliaryText variant={"MenuDropdown"}>
                          {item.label}
                        </AuxiliaryText>
                        <i className="fi fi-rs-angle-down text-sm text-offblack"></i>
                      </button>
                      {item.key === "posts" && postingOpen && (
                        <DropdownRenderer items={item.subMenu} isOpen={postingOpen} className="text-center px-5" />
                      )}
                      {item.key === "messages" && inboxOpen && (
                        <DropdownRenderer items={item.subMenu} isOpen={inboxOpen} className="text-center px-5" />
                      )}
                      {item.key === "quotes" && quotesOpen && (
                        <DropdownRenderer items={item.subMenu} isOpen={quotesOpen} className="text-center px-5" />
                      )}
                      {item.key === "account" && listOpen && (
                        <DropdownRenderer items={item.subMenu} isOpen={listOpen} className="text-center px-5" />
                      )}
                      {item.key === "tickets" && ticketsOpen && (
                        <DropdownRenderer items={item.subMenu} isOpen={ticketsOpen} className="text-center px-5" />
                      )}
                      {item.key === "help" && helpOpen && (
                        <DropdownRenderer items={item.subMenu} isOpen={helpOpen} className="text-center px-5" />
                      )}
                    </>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
// <div className="w-8 h-8 bg-pink rounded-full mr-4 flex justify-center items-end">
//   <IconContext.Provider value={{ className: `text-xl mb-1` }}>
//     <User
//       onClick={() =>
//         setAuth({ user: null, roles: null, accessToken: "" })
//       }
//     />
//   </IconContext.Provider>
// </div>
